// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BillingAddress-module-intro-o5dzW{color:#373a36;font-size:16px;font-weight:var(--weight-light);letter-spacing:0;line-height:23px;margin:0}.BillingAddress-module-radios-mn2m0 label{-webkit-margin-start:0;margin-inline-start:0;grid-gap:4px;gap:4px}.BillingAddress-module-hidden-O9-\\+m{display:none}.BillingAddress-module-messageBox-gxQxu{margin-bottom:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"intro": "BillingAddress-module-intro-o5dzW",
	"radios": "BillingAddress-module-radios-mn2m0",
	"hidden": "BillingAddress-module-hidden-O9-+m",
	"messageBox": "BillingAddress-module-messageBox-gxQxu"
};
export default ___CSS_LOADER_EXPORT___;
